import React from "react";
import "../App.css";
import "animate.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";
AOS.init();
function Skills() {
  const { t } = useTranslation();

  return (
    <div id="skills" className="section">
      <div className="content has-text-centered">
        <h1 className="block is-size-1 has-text-centered underline">
          <span>{t("tr.skills")}</span>
        </h1>
        <center>
          <div
            data-aos="fade-up"
            data-aos-easing="linear"
            data-aos-duration="1200"
            className="card block column is-two-thirds cardDark"
          >
            <h3 className="block has-text-grey"> &lt;Languages&frasl;&gt;</h3>
            <div className="block">
              <img
                alt="icon"
                className="skillsIcon"
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg"
              />
              <img
                alt="icon"
                className="skillsIcon"
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original-wordmark.svg"
              />

              <img
                alt="icon"
                className="skillsIcon"
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original-wordmark.svg"
              />

              <img
                alt="icon"
                className="skillsIcon"
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/c/c-plain.svg"
              />
            </div>
          </div>

          <div
            data-aos="fade-up"
            data-aos-easing="linear"
            data-aos-duration="1000"
            className="card block  column is-two-thirds cardDark"
          >
            <h3 className="block has-text-grey">
              {" "}
              &lt;Web Developement&frasl;&gt;
            </h3>
            <div className="block">
              <img
                alt="icon"
                className="skillsIcon"
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg"
              />

              <img
                alt="icon"
                className="skillsIcon"
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg"
              />
              <img
                alt="icon"
                className="skillsIcon"
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-plain-wordmark.svg"
              />

              <img
                alt="icon"
                className="skillsIcon"
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg"
              />

              <img
                alt="icon"
                className="skillsIcon"
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg"
              />

              <img
                alt="icon"
                className="skillsIcon"
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg"
              />
            </div>
          </div>

          <div
            data-aos="fade-up"
            data-aos-easing="linear"
            data-aos-duration="800"
            className="card block  column is-two-thirds cardDark"
          >
            <h3 className="block has-text-grey">
              {" "}
              &lt;Data Science&frasl;&gt;
            </h3>
            <div className="block">
              <img
                alt="icon"
                className="skillsIcon"
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/numpy/numpy-original-wordmark.svg"
              />

              <img
                alt="icon"
                className="skillsIcon"
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/pandas/pandas-original-wordmark.svg"
              />

              <img
                alt="icon"
                className="skillsIcon"
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/r/r-original.svg"
              />

              <img
                alt="icon"
                className="skillsIcon"
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jupyter/jupyter-original-wordmark.svg"
              />

              <img
                alt="icon"
                className="skillsIcon"
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/anaconda/anaconda-original-wordmark.svg"
              />
            </div>
          </div>
        </center>
      </div>
    </div>
  );
}

export default Skills;
